import React from "react";
import { SensorDataFile, Station } from "@shared/models";

import "./index.scss";

interface CustomLegendProps {
  items: SensorDataFile[] | Partial<Station>[];
}

const CustomLegend = (props: CustomLegendProps) => {
  const { items } = props;

  return (
    <div className="legend-list">
      {items.map((item, index) => (
        <div className="legend-item" key={`item-${index}`}>
          <div className="legend-item-color" style={{ backgroundColor: item.color }} />
          <div className="legend-item-name">
            {(item as SensorDataFile).custom_name || (item as Station).station_code}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomLegend;
